import { Menu, MenuItem, MenuList } from '@material-ui/core';
import React, { useState } from 'react';

import { EActiveFilter, statuses } from '~/src/dash/components/dropdowns/SelectPill/common';
import { QuickFilterIcon } from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  selectedStatus: EActiveFilter;
  handleChange: (status: EActiveFilter) => void;
}

export const ActiveQuickFilter = ({ selectedStatus, handleChange }: IProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeActiveFilter = (status: EActiveFilter) => {
    handleChange(status);
    handleClose();
  };

  return (
    <div>
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          display: 'inline-block',
          borderWidth: 0,
          borderRadius: '6px',
          margin: 0,
          textAlign: 'center',
          padding: '6px 6px 4px 6px',
          backgroundColor: isHovered ? publicaColors.veryLightGray : publicaColors.white,
          cursor: 'pointer',
        }}
      >
        <QuickFilterIcon
          color={isHovered ? publicaColors.veryDarkGray : publicaColors.darkGray}
          style={{ height: '16px' }}
        />
      </button>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          style: { padding: 0 },
        }}
      >
        <MenuList dense>
          {statuses.map((status) => {
            const isActive = selectedStatus === status.value;
            return (
              <MenuItem onClick={() => handleChangeActiveFilter(status.value)}>
                <Cols
                  paddingRight={spacing.base}
                  gap={spacing.extraSmall}
                  style={{ alignItems: 'center' }}
                >
                  <Col displayFlex width={12}>
                    {isActive && (
                      <Text small disableSelect>
                        ●
                      </Text>
                    )}
                  </Col>
                  <Col>
                    <Text small bold={isActive} disableSelect tKey={status.tKey} />
                  </Col>
                </Cols>
              </MenuItem>
            );
          })}
        </MenuList>
      </Menu>
    </div>
  );
};
